import React, {FC} from 'react';

import {Box, DialogContent, Stack, Typography} from '@mui/material';
import {t} from 'i18next';

import {BasketDialogTitle} from './BasketDialogTitle';
import {StyledDialog, StyledBottomSheet} from './styles';

export interface BasketDeliveryDetails3PModal {
  open: boolean;
  sellerName: string;
  deliveryBy: string;
  onClose: () => void;
  isReactNativeWebView: boolean;
}

export const BasketDeliveryDetails3PModal: FC<BasketDeliveryDetails3PModal> = ({
  open,
  onClose,
  sellerName,
  deliveryBy,
  isReactNativeWebView
}) => {
  const ModalContainer = isReactNativeWebView ? StyledBottomSheet : StyledDialog;
  return (
    <ModalContainer open={open} onClose={onClose} anchor="bottom">
      <BasketDialogTitle title={t('sellerDelivery.3p.standardDelivery')} onClose={onClose} />
      <DialogContent>
        <Stack spacing={2}>
          <Box>
            <Typography color="primary" fontWeight={700}>
              {t('sellerDelivery.3p.deliveryHandledBySeller')}
            </Typography>
          </Box>
          <Box>
            <Typography
              dangerouslySetInnerHTML={{
                __html: t('sellerDelivery.3p.sellerWillPrepareOrder', {
                  sellerName,
                  deliveryBy
                })
              }}
            />
          </Box>
          <Box>
            <Typography>{t('sellerDelivery.3p.deliveryPeriodCalculated')}</Typography>
          </Box>
          <Box>
            <Typography>{t('sellerDelivery.3p.makroProPointsCannotApply')}</Typography>
          </Box>
        </Stack>
      </DialogContent>
    </ModalContainer>
  );
};

BasketDeliveryDetails3PModal.displayName = 'BasketDeliveryDetails3PModal';
